import { Outlet, Navigate } from "react-router-dom";

import { useAuthentication } from "../../services/authentication/authentication.context";
import { useEffect, useState } from "react";

export const ProtectedRoute = () => {

const { token, authorizeAccount, isAuthenticated } = useAuthentication();



    return (
        isAuthenticated === false  ? <Navigate to={"/login"} /> : <Outlet />
    )
}